export const orignalI18nNamespaces = {
  fr: {
    app: {
      name: "ORIGNAL 2026",
      tagline: "Notre territoire • Notre gang • Notre aventure",
      login: "Connexion",
      logout: "Déconnexion",
      help: "Aide",
      close: "Fermer",
      save: "Enregistrer",
      cancel: "Annuler",
      add: "Ajouter",
      search: "Rechercher",
      reset: "Réinitialiser",
      empty: "Aucun élément trouvé",
      loading: "Chargement…",
      retry: "Réessayer",
      offlineDraft: "Brouillon conservé localement",
      footerMeta: "Orignal 2026 · cockpit privé de groupe",
      demoBanner: "Préparation de la chasse 2026 · Portneuf · Secteur 4",
      username: "Identifiant",
      password: "Mot de passe",
      signIn: "Entrer dans le camp",
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
      copied: "Copié",
      prev: "Précédent",
      next: "Suivant",
      loginHint: "Les comptes du groupe se connectent avec le mot de passe du groupe. Marcel est administrateur.",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      synced: "Synchronisé",
      toSync: "à synchroniser",
      useGps: "Utiliser ma position",
      provisionalMap: "Localisation provisoire — à confirmer",
      noGps: "Emplacement non disponible",
      archive: "Archiver",
      download: "Télécharger",
      modify: "Modifier",
      open: "Ouvrir",
      dayOf: "Jour",
      invitePending: "Invitation en attente",
      passwordChanged: "Mot de passe mis à jour",
      globalSearch: "Recherche",
    },
    nav: {
      today: "Accueil",
      territory: "Territoire",
      photos: "Photos",
      trip: "Prospection",
      trips: "Chasse 2026",
      hunt: "Chasse 2026",
      map: "Carte",
      add: "Ajouter",
      group: "Groupe",
      more: "Plus",
      messages: "Messages",
      expenses: "Dépenses",
      documents: "Documents",
      history: "Historique",
      settings: "Paramètres",
      tasks: "Tâches",
      gear: "Matériel",
      search: "Recherche",
      notifications: "Notifications",
      admin: "Administration",
      observations: "Observations",
      lodging: "Chalet",
      prep: "Préparation",
      myStuff: "Mes affaires",
      menu: "Menu",
      know: "À savoir",
      vehicles: "Véhicules",
    },
    chrome: {
      sub: "Portneuf · Secteur 4",
      menu: "Menu",
      main: "Navigation principale",
      cockpitOnly: "Tout se fait depuis l'accueil.",
    },
    stayRules: {
      water: "Eau non potable",
      bedding: "Literie à apporter",
      nordquest: "Carte terrain : NordQuest",
      sopfeu: "SOPFEU",
      atv: "VTT selon sentiers",
      drones: "Drones interdits",
    },
    cockpit: {
      addTask: "+ Tâche",
      addPoint: "+ Point",
      addExpense: "+ Dépense",
      addPhoto: "+ Photo",
      kpiPrep: "Préparation",
      kpiTasks: "Tâches ouvertes",
      kpiPoints: "Points",
      kpiSpend: "Dépenses",
      kpiReady: "Membres prêts",
      sepaqFull: "Checklist Sépaq complète",
    },
    today: {
      title: "Aujourd'hui",
      subtitle: "La situation du groupe en un coup d'œil",
      nextTrip: "Prochaine sortie",
      dates: "Dates",
      sector: "Secteur",
      participants: "Participants",
      countdown: "Compte à rebours",
      datesPending: "Dates à confirmer",
      openTrip: "Ouvrir le séjour",
      addPoint: "Ajouter un point",
      addPhoto: "Ajouter une photo",
      addObservation: "Faire une observation",
      writeGroup: "Écrire au groupe",
      since: "Depuis ma dernière visite",
      newPhotos: "Nouvelles photos",
      newPoints: "Nouveaux points",
      newObservations: "Nouvelles observations",
      newMessages: "Nouveaux messages",
      newExpenses: "Dépenses ajoutées",
      openTasks: "Tâches à faire",
      map: "Carte territoire",
      recentPhotos: "Photos récentes",
      noPhotos: "Aucune photo pour l'instant",
      group: "Groupe",
      activity: "Activité récente",
      revisit: "Endroits à revisiter",
      urgentTasks: "Tâches urgentes",
      whatFound: "Qu'avez-vous trouvé ?",
      observe: "Observer",
      photo: "Photo",
      territory: "Terrain",
      stay: "Séjour",
      now: "Maintenant",
      foodPending: "Nourriture à confirmer",
      confirmedMembers: "Membres confirmés",
      nextStep: "Prochaine étape",
      menuCard: "Menu du weekend",
      seeMenu: "Voir menu complet",
      createTask: "Créer une tâche",
      myTasks: "Mes tâches",
      pointsCount: "points",
      priorityCount: "prioritaires",
      revisitCount: "à revisiter",
      openMap: "Ouvrir la carte",
      expensesCard: "Dépenses communes",
      noExpense: "Aucune dépense entrée",
      portneufHistory: "Historique Portneuf disponible",
      ourGround: "Notre territoire",
      addObs: "Ajouter observation",
      seePoints: "Voir nos points",
    },
    hunt: {
      kicker: "Notre chasse",
      title: "Chasse à l'orignal 2026",
      subtitle: "2–9 octobre 2026 · Portneuf · Secteur 4",
      datesLine: "Du 2 octobre au 9 octobre 2026",
      place: "Portneuf · Secteur 4",
      datesShort: "2–9 octobre 2026",
      departLine: "Départ : 2 octobre vers 6 h",
      departDay: "Vendredi 2 octobre",
      arriveLine: "Arrivée prévue entre 12 h et 13 h",
      arriveShort: "12 h–13 h",
      fieldMapLabel: "Carte terrain",
      fieldMap: "NordQuest",
      daysBefore: "jours avant le départ",
      work: {
        myTasks: "Mes choses à faire",
        gangTasks: "La gang",
        meals: "Repas",
        gear: "Matériel",
        vehicles: "Véhicules",
        organization: "Organisation",
        todo: "À faire",
        done: "Fait",
        todoN: "{n} à faire",
        allDone: "Tout est fait ✓",
        humour: "Humour et anecdotes",
        humourTitle: "Les jokes de la gang",
        jokes: "Jokes",
        anecdotes: "Anecdotes",
        askMarcel: "À confirmer avec Marcel",
        photoValidate: "À valider par Marcel",
        imageJoke: "Image humoristique",
        comingInfo: "Informations confirmées à venir",
        orgTitle: "Organisation de la chasse 2026",
        orgSubtitle: "2 au 9 octobre 2026 · Portneuf · Secteur 4 · Desrochers",
        sepaqOfficial: "Informations officielles Sépaq",
        groupInfo: "Information du groupe",
        departHeading: "Départ",
        arriveHeading: "Arrivée prévue",
        registration: "Enregistrement",
        cabin: "Chalet",
        huntSection: "Chasse",
        services: "Services",
        onSite: "Sur place",
        nearby: "Services proches",
        rules: "À savoir",
        officialDoc: "Voir le document officiel Sépaq",
        pdfTitle: "Document officiel Sépaq",
        confirmTitle: "À confirmer avec Sépaq",
        confirmStatus: "À confirmer",
        sepaqReady: "Organisation officielle Sépaq disponible",
        huntOrgSummary: "Départ : vers 6 h · Enregistrement Desrochers : 13 h 45 · Début chasse : 16 h 30",
        bring: "À apporter",
        schedule: "Horaire",
        territory: "Territoire",
        group: "Groupe",
        notes: "Notes",
        expensesTitle: "Dépenses",
        photos: "Photos",
        map: "Carte",
        story: "Histoire",
        bilan: "Bilan",
        prepProspectLine: "Préparation de la prospection — terminée",
        mealPlanned: "Repas prévu",
        evening: "Soirée",
        driver: "Conducteur",
        linkedGear: "Matériel associé",
        ready: "Prêt",
        addTask: "Ajouter une tâche",
        taskPlaceholder: "Quoi faire",
        edit: "Modifier",
        reassign: "Réassigner",
        reopen: "Réouvrir",
        oneThing: "1 chose à faire",
        nThings: "{n} choses à faire",
        remove: "Supprimer",
        save: "Enregistrer",
        confirmDelete: "Voulez-vous vraiment supprimer cet élément ?",
        candidates: "Candidats Messenger",
        approve: "Approuver",
        duplicates: "Doublons à confirmer",
        trash: "Corbeille",
        restore: "Annuler la suppression",
        addNote: "Ajouter une note",
        downloadPdf: "Télécharger le PDF",
        openPdf: "Ouvrir le PDF",
        pdfPreview: "Aperçu du document officiel",
        pierreCheck: "Un message du 26 septembre écrit « Pierre : saucisse, patates ». Le souper officiel reste le poulet tant que Marcel ne le change pas.",
        person: "Personne",
        everyone: "Tous",
        messenger: "On complétera avec Messenger.",
        datesBand: "2 au 9 octobre 2026",
        chalet: "Chalet",
        confirmed: "Informations confirmées",
      },
      bilanWhen: "Après le 9 octobre",
      toolHistory: "Outil utilisé lors de la prospection d’août 2026 : Avenza",
      phasePrep: "Préparation de la chasse 2026",
      noHuntDate: "Date de chasse à confirmer",
      nextStep: "Prochaine étape",
      prepare: "Préparer la chasse 2026",
      nextItems: {
        gear: "Matériel",
        avenza: "Avenza",
        vehicles: "Véhicules",
        food: "Nourriture",
        tasks: "Tâches importantes",
      },
      todo: "À faire avant la chasse",
      todoEmpty: "Rien d'urgent pour le moment.",
      learned: "Ce qu'on a appris",
      learnedEmpty: "Les notes de terrain s'afficheront ici.",
      learnedKinds: {
        revisit: "À revoir",
        access: "Accès",
        path: "Chemin",
        promising: "Zone prometteuse",
        obstacle: "Obstacle",
        moose: "Orignal",
        note: "Note terrain",
        souvenir: "Souvenir",
      },
      ourProspect: "Notre prospection",
      completed: "Terminée",
      current: "En cours",
      upcoming: "À venir",
      eightPeople: "8 personnes · 4 couples",
      sevenPeople: "7 personnes",
      sixHunters: "6 chasseurs",
      seePhotos: "Voir les photos",
      seeExpenses: "Voir les dépenses",
      seePoints: "Voir les points",
      seeSouvenirs: "Voir les souvenirs",
      seeDocs: "Voir les documents",
      ourGround: "Notre territoire",
      sectorLine: "Secteur 4 — 54,55 km²",
      strategicPoints: "points stratégiques",
      revisitCount: "à revisiter",
      priorityCount: "prioritaires",
      lastObs: "Dernière observation",
      openMap: "Ouvrir la carte",
      ourPhotos: "Nos photos",
      noPhotos: "Les photos du week-end s'afficheront ici.",
      ourGang: "Notre gang",
      ourCosts: "Nos dépenses",
      bilanPending: "Bilan à finaliser",
      ourHunt: "Notre chasse",
      sevenPresent: "7 personnes présentes",
      phaseNow: "Phase actuelle",
      prepProspectTitle: "Préparation prospection",
      prepHuntTitle: "Préparation avant la chasse",
      huntLiveTitle: "La chasse 2026",
      afterHuntTitle: "Après la chasse",
      nowPreparing: "Qu'est-ce qu'on prépare maintenant ?",
      detail: "Détail",
      cycleNav: "Phases de la chasse",
      tabMap: "Carte",
      tabStory: "Histoire",
      tabBilan: "Bilan",
      gpsAndPoints: "Photos GPS + points terrain",
      noPhotoGpsShort: "aucune photo GPS",
      unknown: "À confirmer",
      joseeContrib: "Contribution avant le départ",
      prepTopics: {
        lodge: "Chalet Desrochers",
        transport: "transport",
        food: "nourriture",
        maps: "cartes",
        group: "groupe",
        docs: "documents",
      },
      afterDest: {
        photos: "photos",
        results: "résultats",
        souvenirs: "souvenirs",
        expenses: "dépenses",
        observations: "observations",
        final: "bilan final",
      },
      rail: {
        prep_prospect: "Préparation prospection",
        prospection: "Prospection",
        preparation_hunt: "Préparation chasse",
        hunt: "Chasse",
        bilan: "Bilan",
      },
      mobileTabs: {
        prep_prospect: "Avant",
        prospection: "Prospection",
        preparation_hunt: "Prépa",
        hunt: "Chasse",
        bilan: "Bilan",
      },
      phases: {
        prep_prospect: "Préparation prospection",
        prospection: "Prospection",
        preparation_hunt: "Préparation",
        hunt: "Chasse",
        bilan: "Bilan",
      },
      openProspect: "Voir la prospection",
      huntCard: "Chasse 2026",
      timeline: "Le week-end",
      timelineSteps: {
        prep: "préparation",
        depart: "départ",
        arrive: "arrivée",
        field: "terrain",
        meals: "repas",
        return: "retour",
      },
      weekendPeople: "Présents le week-end",
      pierreRobinOut: "Pierre n'était pas à ce week-end. Il reste dans la chasse. Robin n'y était pas non plus, et il n'est pas de cette chasse.",
      seeProspect: "Revoir la prospection",
      souvenirsTitle: "Souvenirs de la prospection",
      souvenirsLead: "Photos, repas, anecdotes — sans données techniques.",
      anecdotes: "Anecdotes",
      meals: "Repas",
      groupShots: "Groupe",
      vehicleShots: "Véhicules",
      prospectTitle: "Prospection Portneuf",
      groupHunt: "Groupe chasse 2026",
      prospectDates: "28–30 août 2026",
      weekendStory: "Notre prospection — le week-end en images et en histoire",
      weekendSub: "28–30 août 2026 · Chalet Desrochers · Secteur 4",
      photosProspect: "Nos photos de prospection",
      photosWord: "photos",
      souvenirsWord: "souvenirs",
      pointsWord: "points terrain",
      lived: "Ce qu'on a vécu",
      livedEmpty: "Les souvenirs s'afficheront ici après l'import du week-end.",
      seeTalk: "Lire les discussions",
      discussions: "Nos discussions",
      talkEmpty: "Aucune discussion à afficher.",
      talkFilters: {
        all: "Toutes",
        organisation: "Organisation",
        bouffe: "Bouffe",
        territoire: "Territoire",
        vehicules: "Véhicules",
        depenses: "Dépenses",
        souvenirs: "Souvenirs",
      },
      tabPhotos: "Photos",
      tabTalk: "Discussions",
      tabGround: "Territoire",
      tabSouvenirs: "Souvenirs",
      tabCosts: "Dépenses",
      nextChapter: "Prochain chapitre",
      perCouple: "/ couple",
      albumName: "Prospection Portneuf — 28–30 août 2026",
      chapterResume: "Résumé",
      chapterMap: "Carte",
      prospectPoints: "Nos points de prospection",
      nosSouvenirs: "Nos souvenirs",
      reviewWeekend: "Revoir notre fin de semaine",
      gangPresent: "La gang présente",
      joseeAway: "Josée n'était pas sur place (malade).",
      ourStory: "Notre histoire",
      storyLead: "Heures d'envoi Messenger. Les photos n'ont plus d'EXIF ni de GPS (Facebook les a retirés). Titres à confirmer.",
      suggested: "Titre suggéré",
      mapWeekend: "Carte du week-end",
      noPhotoGps: "Aucune photo de ce lot n'a de GPS. Secteur 4 et points terrain seulement.",
      allPhotos: "Toutes les photos",
      weekendCost: "Ce que la fin de semaine nous a coûté",
    },
    expedition: {
      kicker: "Expédition",
      title: "EXPÉDITION PORTNEUF 2026",
      subtitle: "Chalet Desrochers — Secteur 4",
      departBadge: "28–30 août 2026",
      reserveBadge: "Réserve faunique de Portneuf",
      sectorBadge: "Secteur de chasse no 4",
      reconBadge: "54,55 km²",
      memberBadge: "6 membres",
      countdown: "Départ tôt le matin — heure exacte à confirmer",
      arrive: "Arrivée officielle chalet à partir de 17 h",
      mapNote: "Limite officielle secteur 4 — 54,55 km². Carte terrain : NordQuest.",
      timelineTitle: "Itinéraire",
      compactLine: "Secteur 4 → Chalet Desrochers → Retour dimanche 13 h 30",
      summary: "Vendredi 28 au dimanche 30 août 2026. Chalet Desrochers, secteur de chasse no 4, 54,55 km².",
      ourLodge: "Notre chalet",
      seeLodge: "Voir la fiche",
      seeSepaq: "Voir sur Sépaq",
      seePhotos: "Voir les photos officielles",
      territoryBlock: "Secteur 4 — 54,55 km²",
      seeMap: "Voir la carte",
      fullscreen: "Plein écran",
      myPoints: "Mes points",
      openNav: "Ouvrir navigation",
      steps: { prep: "Préparation", friday: "Vendredi 28", saturday: "Samedi 29", sunday: "Dimanche 30" },
      days: { prep: "Avant le départ", friday: "Départ tôt le matin", saturday: "Journée terrain", sunday: "Libération 13 h 30" },
      places: { prep: "Checklist Sépaq", friday: "Chalet Desrochers dès 17 h", saturday: "Secteur 4", sunday: "Chalet Desrochers" },
      notes: { prep: "Eau, literie, NordQuest, documents.", friday: "Charcuteries. Vin : Josée.", saturday: "Crêpes Natalie. Filet mignon + patates dauphinoises.", sunday: "Déjeuner rapide préparé d’avance." },
    },
    avenza: {
      open: "Ouvrir NordQuest",
      copy: "Copier les coordonnées",
      exportGpx: "Exporter GPX",
      importGpx: "Importer GPX / KML",
      note: "Ancien outil utilisé pendant la prospection : Avenza. La carte terrain du groupe se prépare maintenant dans NordQuest.",
      officialMap: "Ancien outil — prospection août",
      lakeTitle: "Lac Desrochers",
      sourceLine: "Source : Sépaq · Plateforme : Avenza Maps",
      lakeRef: "Référence lac — distincte du Chalet Desrochers et du secteur 4.",
      seeOfficial: "Voir la carte officielle Avenza",
      qrAlt: "QR vers la fiche Avenza Lac Desrochers",
      downloaded: "Carte Avenza téléchargée",
      yes: "Oui",
      no: "Non",
      unknown: "À confirmer",
      importBtn: "Importer données Avenza",
      exportMineGpx: "Exporter mes points GPX",
      exportMineKml: "Exporter mes points KML",
      exportAllGpx: "Exporter le groupe GPX",
      exportAllKml: "Exporter le groupe KML",
      imported: "{n} points · {t} traces",
      importQueued: "Fichier gardé hors-ligne — import au retour réseau.",
      importNeedNet: "L'import nécessite une connexion. Le fichier n'a pas été perdu : réessayez.",
      openPanel: "Avenza",
    },
    territory: {
      title: "Territoire",
      subtitle: "Points, chemins et observations sur le terrain",
      search: "Rechercher un point",
      filterCategory: "Catégorie",
      filterSector: "Secteur",
      all: "Tous",
      empty: "Aucun point trouvé",
      add: "Ajouter un point",
      name: "Nom",
      category: "Catégorie",
      comment: "Commentaire",
      interest: "Intérêt",
      save: "Enregistrer le point",
      detail: "Fiche du point",
      expand: "Agrandir",
      openMap: "Carte",
      recenter: "Recentrer",
      layers: { standard: "Standard", topo: "Relief", satellite: "Satellite" },
    },
    photos: {
      title: "Photos",
      subtitle: "Souvenirs, traces et territoire",
      add: "Ajouter une photo",
      empty: "Aucune photo trouvée",
      search: "Rechercher",
      category: "Catégorie",
      comment: "Commentaire",
      albumTitle: "Toutes les photos",
      albumLead: "Ordre chronologique. Lieu seulement s'il y a un GPS réel.",
      noPlace: "Lieu non déterminé",
      missingFiles: "fichier(s) illisible(s) — visibles ici seulement en admin.",
    },
    trip: {
      title: "Séjour",
      subtitle: "Chalet Desrochers — préparation",
      lodgeTitle: "Chalet Desrochers",
      reception: "Accueil",
      motorized: "Déplacements motorisés",
      nearby: "Services à proximité",
      navField: "Navigation terrain",
      food: "Nourriture",
      tasks: "Tâches",
      expenses: "Dépenses",
      resources: "Ressources utiles",
      toConfirm: "À confirmer",
      item: "Élément",
      responsible: "Responsable",
      quantity: "Quantité",
      cost: "Coût",
      participants: "Participants",
      historyTitle: "Historique Portneuf",
      souvenirsTitle: "Souvenirs",
    },
    lodging: {
      title: "Chalet Desrochers",
      subtitle: "Hébergement officiel du séjour",
      unknown: "Non confirmé",
      source: "Source officielle",
      folder: "Portneuf / Desrochers",
      photosNote: "Les photos officielles restent sur le site Sépaq. Aucune photo Sépaq n'est réutilisée ici.",
      unit: "Unité / numéro",
      gps: "Coordonnées du chalet",
      capacity: "Capacité",
      holder: "Titulaire",
      water: "Eau non potable — apporter de l’eau embouteillée",
      waterStatus: "CRITIQUE",
      groupBed: "Recommandation du groupe : sac de couchage individuel",
      provided: "Fourni : oreillers, tapis de bain, linge à vaisselle, vaisselle, ustensiles, chaudrons, poêlons, percolateur ou cafetière à piston.",
      notProvided: "Non fourni : sel, poivre, huile, sucre, nourriture de base.",
    },
    prep: {
      title: "Préparation du séjour",
      subtitle: "Chalet Desrochers — Réserve faunique de Portneuf",
      card: "Préparation du séjour",
      readyOf: "prêts",
      toLoad: "à charger",
      criticalLeft: "critiques à vérifier",
      beforeLeave: "À régler avant le départ",
      who: "Qui apporte quoi",
      knownOnly: "Responsabilités connues — rien n'est inventé",
      essentials: "Essentiel pour notre séjour",
      essentialsReady: "essentiels prêts",
      seeFull: "Voir la checklist Sépaq complète",
      myTasks: "Tâches qui me concernent",
      loading: "Chargement",
      depart: "Prêt à partir ?",
      go: "PRÊTS À PARTIR",
      left: "éléments à vérifier",
      filterAll: "Tout",
      filterMine: "Moi",
      filterGroup: "Groupe",
      filterCrit: "Critique",
      winter: "Afficher équipement hiver",
      hideWinter: "Masquer hiver",
      markReady: "Prêt",
      markLoaded: "Chargé",
      markCheck: "Confirmé",
      avenzaBtn: "Ouvrir NordQuest",
      avenzaWarn: "La carte hors ligne se prépare dans NordQuest avant le départ.",
      source: "Source officielle",
      sourceNote: "Sépaq — aide-mémoire chalet. Contenu de référence.",
      openPdf: "Ouvrir",
      downloadPdf: "Télécharger",
      addSepaq: "Ajouter checklist Sépaq",
      hunting: "Matériel de chasse",
      huntingEmpty: "Vide pour l'instant — à remplir plus tard.",
      joseeDuty: "nourriture",
      natalieDuty: "déjeuner samedi",
      grocery: "Épicerie commune",
      menus: "Menus",
      qty: "Quantité",
      note: "Commentaire",
      expense: "Créer une dépense",
      personal: "Préparation personnelle",
      meals: { friday: "Vendredi", saturday: "Samedi", sunday: "Dimanche", other: "Autres repas" },
      cats: { important: "Important", vetements: "Vêtements", hiver: "Vêtements (hiver)", effets: "Effets personnels", groupe: "Équipement de groupe", epicerie: "Épicerie", chasse: "Matériel de chasse" },
    },
    nordquest: {
      groupTitle: "NordQuest — préparation du groupe",
      readyOf: "chasseurs prêts",
      pointsOfficial: "9 points officiels",
      sector: "secteur 4",
      offline: "carte hors ligne",
      updated: "dernière mise à jour",
      noneYet: "pas encore",
      versionLine: "9 points Éric — prospection 29 août 2026",
      version: "Version 1",
      title: "Préparer mon NordQuest",
      subtitle: "Carte terrain officielle du groupe — Portneuf, secteur 4",
      open: "Ouvrir NordQuest",
      step1: "1. Installer NordQuest",
      appStore: "iPhone",
      play: "Android",
      installed: "NordQuest installé ✅",
      installedOff: "Confirmer : NordQuest installé",
      step2: "2. Ouvrir la carte de Portneuf",
      step2how: "NordQuest → Territoires → Sépaq → Réserve faunique de Portneuf",
      step2sector: "Sépaq → Portneuf → Secteur 4",
      mapOpen: "Carte Portneuf ouverte ✅",
      mapOpenOff: "Confirmer : carte Portneuf ouverte",
      step3: "3. Télécharger nos 9 points",
      download: "Télécharger les 9 points d’Éric",
      gpxFallback: "Le KML ne fonctionne pas ? Télécharger le GPX",
      step4: "4. Importer dans NordQuest",
      importTitle: "Importer les points",
      importSteps: [
        "Ouvrir NordQuest",
        "Ouvrir la carte/territoire Portneuf",
        "Appuyer sur Actions",
        "Choisir Importer",
        "Choisir le fichier KML téléchargé",
        "Confirmer",
        "Vérifier les 9 points sur la carte",
      ],
      step5: "5. Vérifier les points",
      verifyTitle: "Vérification",
      verifyLead: "Tu dois voir 9 points",
      seeNine: "Je vois les 9 points ✅",
      seeNineOff: "Confirmer : je vois les 9 points",
      history: "Ancien outil utilisé pendant la prospection : Avenza",
      step6: "6. Carte hors ligne",
      woods: "Préparer pour le bois",
      woodsHow: "Télécharger la carte NordQuest pour utilisation hors réseau avant de partir.",
      offlineReady: "Carte hors ligne prête ✅",
      offlineTodo: "À faire",
      imReady: "Je suis prêt",
      track: "Suivi des 6 chasseurs",
      yes: "Oui",
      no: "Non",
      rowInstalled: "NordQuest installé",
      rowMap: "Carte Portneuf ouverte",
      rowPoints: "9 points importés",
      rowOffline: "Carte hors ligne",
      rowReady: "Prêt",
      associates: "Chantal, Josée, Natalie et Martine peuvent consulter. Le suivi concerne les 6 chasseurs.",
      chalet: "Installation au chalet",
      chaletHint: "Touche un nom pour voir ce qui reste.",
      qrCaption: "Au chalet, scanne ce code pour ouvrir cette page.",
      notHunter: "Le suivi principal concerne les 6 chasseurs.",
      mapNote: "Les nouveaux points terrain sont maintenant créés dans NordQuest.",
    },
    menu: {
      title: "Menu du séjour",
      subtitle: "Coordination nourriture : Josée Gravelle",
      lead: "Josée Gravelle",
      coord: "Coordination nourriture : Josée Gravelle",
      fridayNoon: "Vendredi midi",
      fridayEve: "Vendredi soir",
      satBreakfast: "Samedi matin",
      satLunch: "Samedi midi",
      satDinner: "Samedi soir",
      sunday: "Dimanche matin",
      drinks: "Boissons",
      drinksRule: "Chacun apporte ses propres boissons, alcoolisées ou non.",
      createTask: "Créer une tâche",
      allergies: "Allergies alimentaires : aucune confirmée",
      snacks: "Snacks pour les camions",
      hunters: "Chasseurs",
      lodge: "Au chalet",
    },
    know: {
      title: "À savoir avant le départ",
      subtitle: "Règles confirmées — Confirmation Sépaq",
    },
    vehicles: {
      title: "Véhicules",
      subtitle: "Photos réelles — détails à compléter",
      pending: "Détails à compléter",
    },
    group: {
      title: "Groupe",
      subtitle: "Notre gang de chasse 2026",
      toConfirm: "Membre à confirmer",
      active: "Actif",
      admin: "Administrateur",
      member: "Membre",
      associated: "Personne associée",
      associatedTitle: "Personnes associées",
      organizer: "Organisateur",
      hunter: "Chasseur",
      official: "Chasseurs / organisateurs",
      foodLead: "Responsable nourriture",
    },
    more: {
      title: "Plus",
      subtitle: "Messages, dépenses, documents et réglages",
    },
    messages: {
      title: "Messages",
      subtitle: "Canaux du groupe",
      write: "Écrire",
      send: "Envoyer",
      empty: "Aucun message dans ce canal",
      source: "Source",
      importedSources: "Sources importées",
      importedNote: "Messenger — extrait fourni manuellement. Pas d'accès au groupe complet.",
    },
    expenses: {
      title: "Dépenses",
      subtitle: "Qui a payé, qui doit quoi",
      add: "Ajouter une dépense",
      payer: "Payé par",
      amount: "Montant",
      description: "Description",
      category: "Catégorie",
      total: "Total",
      perPerson: "Par personne",
      whoOwes: "Qui rembourse qui",
      empty: "Aucune dépense trouvée",
      tripCard: "Dépenses du séjour",
      paidByMe: "Payé par moi",
      myShare: "Ma part",
      balance: "Solde",
      rule: "Tout le monde fait le total des dépenses communes qu’il a payées, puis on additionne et on divise à parts égales entre les 6 membres officiels.",
      none: "Aucune dépense entrée",
      includeLodge: "Inclure dans dépenses communes",
      pendingLodge: "Chalet Desrochers — partage non activé",
      reminder: "Chaque personne entre ses dépenses communes.",
      missing: "dépenses manquantes",
    },
    documents: {
      title: "Documents",
      subtitle: "Permis, cartes et notes",
      empty: "Aucun document pour l'instant",
      folder: "Portneuf / Desrochers",
      open: "Ouvrir",
      aideMemoire: "Aide-mémoire — Équipement pour un séjour en chalet",
      officialMap: "Réserve faunique de Portneuf — Chasse à l’orignal 2026 — Secteur 4",
      reservation: "Confirmation de réservation",
      kmz: "POR_Secteur_Chasse_Orignal.kmz",
      officialMaps: "Cartes officielles",
    },
    history: {
      title: "Historique",
      subtitle: "Journal des actions du groupe",
      empty: "Aucune activité",
      avenzaPast: "Ancien outil utilisé pendant la prospection : Avenza",
    },
    settings: {
      title: "Paramètres",
      subtitle: "Compte, version et environnement",
      version: "Version",
      env: "Environnement",
      build: "Build",
      commit: "Commit",
      deployed: "Déploiement",
    },
    status: {
      preparation: "Préparation",
      confirmed: "Confirmée",
      in_progress: "En cours",
      cancelled: "Annulée",
      completed: "Terminée",
      upcoming: "À venir",
      current: "En cours",
      to_confirm: "À confirmer",
      active: "Actif",
      open: "À faire",
      doing: "En cours",
      done: "Complétée",
      member_to_confirm: "Membre à confirmer",
      invitation_pending: "Invitation en attente",
      to_bring: "À apporter",
      ready: "Prêt",
      loaded: "Chargé",
      to_plan: "À prévoir",
      assigned: "Assigné",
      to_check: "À vérifier",
      not_needed: "Non requis",
      faible: "Faible",
      interessant: "Intéressant",
      important: "Important",
      prioritaire: "Prioritaire",
    },
    observations: { title: "Observations", subtitle: "Ce que le groupe a vu sur le terrain", empty: "Aucune observation", add: "Ajouter une observation", note: "Note facultative" },
    tasksPage: {
      title: "Tâches",
      subtitle: "Qui fait quoi avant et pendant la sortie",
      empty: "Aucune tâche",
      create: "Créer une tâche",
      titleField: "Titre",
      desc: "Description",
      assignee: "Responsable",
      unassigned: "Non assignée",
      comment: "Commentaire",
      addComment: "Ajouter",
      reopen: "Réouvrir",
      prioNormal: "Normale",
      prioHigh: "Haute",
      prioUrgent: "Urgente",
      mine: "Mes tâches",
    },
    mapUi: {
      myPos: "Ma position",
      strategic: "Point stratégique",
      fitSector: "Voir tout le secteur",
      filters: "Filtres",
      layers: "Couches",
      show: "Afficher",
      allMembers: "Tous les chasseurs",
      locating: "Recherche de position…",
      denied: "Permission de localisation refusée",
      noGps: "Position indisponible",
      useHere: "Position actuelle",
      tapMap: "Toucher la carte",
      needPlace: "Choisissez une position",
      revisit: "À revisiter",
      views: { all: "Tout", mine: "Mes points", others: "Les autres", priority: "Prioritaires", revisit: "À revisiter", obs: "Observations", acces: "Accès" },
      interest: { normal: "Normal", interesting: "Intéressant", important: "Important", priority: "Prioritaire" },
    },
    gear: { title: "Matériel", subtitle: "Liste partagée — rien n'est inventé", empty: "Aucun matériel pour l'instant" },
    searchPage: { title: "Recherche", subtitle: "Messages, photos, points, membres, sorties", empty: "Aucun résultat" },
    notifications: { title: "Notifications", subtitle: "Mentions, tâches et sorties", empty: "Aucune notification" },
    admin: { title: "Administration", subtitle: "Invitations, santé, version et import Facebook", invite: "Inviter un membre", system: "Système" },
    rebuild: {
      title: "Reconstruire notre prospection",
      lead: "DEV seulement. Confirmez ou corrigez chaque moment. Rien ne part en PROD.",
      present: "Présents",
      answerPh: "Votre réponse",
      saveAnswer: "Enregistrer",
      saved: "Enregistré",
      suggested: "Titre suggéré",
      unconfirmed: "à confirmer",
      confirm: "Confirmer",
      correct: "Corriger",
    },
    fbImport: {
      title: "Import Facebook Portneuf",
      lead: "Validation humaine obligatoire. Rien n’entre dans le cockpit sans approbation.",
      load: "Charger les candidats (local)",
      loaded: "Candidats chargés",
      loadError: "Dossier d’extract introuvable",
      previewImport: "Résumé avant import",
      confirmImport: "Importer les éléments approuvés",
      cancelImport: "Annuler cet import",
      imported: "Import terminé",
      importError: "Import impossible",
      noMass: "Pas d’import massif : chaque élément reste À valider jusqu’à ton OK.",
      authors: "Auteurs Facebook",
      ambiguous: "Auteur ambigu — Chantal / Luc",
      historical: "Auteur historique (pas membre actif)",
      knownExpenses: "Dépenses connues à valider",
      found: "trouvée",
      missing: "non trouvée",
      approve: "Approuver",
      reject: "Rejeter",
      bulkApproveCat: "Catégorie + approuver la sélection",
      bulkReject: "Rejeter la sélection",
      duplicate: "doublon bilan",
      keep: "à garder",
      confirmDesc: "Description à confirmer",
      previewLine: "{m} messages · {p} photos · {e} dépenses · {d} documents · {s} souvenirs",
      tabs: {
        resume: "Résumé", messages: "Messages", depenses: "Dépenses", photos: "Photos",
        territoire: "Territoire", nourriture: "Nourriture", taches: "Tâches", sejour: "Séjour",
        vehicules: "Véhicules", souvenirs: "Souvenirs", ignores: "Ignorés", importes: "Importés",
      },
      kpis: {
        messages: "Messages", photos: "Photos", videos: "Vidéos", attachments: "Pièces jointes",
        expense_rows: "Dépenses candidates", tache: "Tâches", nourriture: "Nourriture",
        territoire: "Territoire", vehicule: "Véhicules", sejour: "Séjour", souvenir: "Souvenirs",
      },
      status: { to_validate: "À valider", approved: "Approuvé", rejected: "Rejeté", imported: "Importé", sensitive_excluded: "Secret exclu" },
      photoCats: {
        groupe: "Groupe", chalet: "Chalet", territoire: "Territoire", repas: "Repas", vehicule: "Véhicule",
        facture: "Facture", document_financier: "Document financier", souvenir: "Souvenir", autre: "Autre", a_classer: "À classer",
      },
    },
    trips: { title: "Séjours", subtitle: "Préparation, en cours, terminées", empty: "Aucune sortie" },
    categories: {
      chemin: "Chemin",
      sentier: "Sentier",
      frottage: "Frottage",
      souille: "Souille",
      passage: "Passage",
      nourriture_naturelle: "Nourriture naturelle",
      secteur_interessant: "Secteur intéressant",
      acces: "Accès",
      camp: "Camp",
      stationnement: "Stationnement",
      observation: "Observation",
      orignal: "Observation orignal",
      feces: "Fèces",
      zone_nourriciere: "Zone nourricière",
      position: "Position intéressante",
      cache: "Installation / cache",
      traces: "Traces",
      eau: "Point d'eau",
      obstacle: "Obstacle",
      revoir: "Secteur à revoir",
      photo: "Photo",
      autre: "Autre",
      territoire: "Territoire",
      groupe: "Groupe",
      equipement: "Équipement",
      nourriture: "Nourriture",
      souvenir: "Souvenir",
      essence: "Essence",
      hebergement: "Hébergement",
      materiel: "Matériel",
      permis: "Permis",
      transport: "Transport",
      vehicule: "Véhicules",
      chalet: "Chalet",
      repas: "Repas",
      facture: "Facture",
      boissons_communes: "Boissons communes",
      essence_commune: "Essence commune",
      glace: "Glace",
      a_classer: "À classer",
    },
    channels: {
      general: "Général",
      territoire: "Territoire",
      bouffe: "Bouffe",
      organisation: "Organisation",
      photos: "Photos",
    },
    errors: {
      login: "Identifiant ou mot de passe invalide",
      network: "Réseau indisponible — le brouillon est conservé",
      notFound: "Page introuvable",
      expired: "Session expirée — reconnectez-vous",
    },
    help: {
      close: "Fermer l'aide",
    },
    demo: {
      badge: "[DÉMO]",
      imported: "Import Messenger",
    },
  },
  en: {
    app: {
      name: "ORIGNAL 2026",
      tagline: "Our territory • Our crew • Our adventure",
      login: "Sign in",
      logout: "Sign out",
      help: "Help",
      close: "Close",
      save: "Save",
      cancel: "Cancel",
      add: "Add",
      search: "Search",
      reset: "Reset",
      empty: "Nothing found",
      loading: "Loading…",
      retry: "Try again",
      offlineDraft: "Draft kept on this device",
      footerMeta: "Orignal 2026 · private group cockpit",
      demoBanner: "Getting ready for hunt 2026 · Portneuf · Sector 4",
      username: "Username",
      password: "Password",
      signIn: "Enter the camp",
      showPassword: "Show password",
      hidePassword: "Hide password",
      copied: "Copied",
      prev: "Previous",
      next: "Next",
      loginHint: "Group accounts use the group password. Marcel is the administrator.",
      changePassword: "Change password",
      currentPassword: "Current password",
      newPassword: "New password",
      synced: "Synced",
      toSync: "to sync",
      useGps: "Use my location",
      provisionalMap: "Provisional location — to confirm",
      noGps: "Location not available",
      archive: "Archive",
      download: "Download",
      modify: "Edit",
      open: "Open",
      dayOf: "Day",
      invitePending: "Invitation pending",
      passwordChanged: "Password updated",
      globalSearch: "Search",
    },
    nav: {
      today: "Home",
      territory: "Territory",
      photos: "Photos",
      trip: "Scouting",
      trips: "Hunt 2026",
      hunt: "Hunt 2026",
      map: "Map",
      add: "Add",
      group: "Group",
      more: "More",
      messages: "Messages",
      expenses: "Expenses",
      documents: "Documents",
      history: "History",
      settings: "Settings",
      tasks: "Tasks",
      gear: "Gear",
      search: "Search",
      notifications: "Notifications",
      admin: "Admin",
      observations: "Observations",
      lodging: "Cabin",
      prep: "Prep",
      myStuff: "My kit",
      menu: "Menu",
      know: "Before leaving",
      vehicles: "Vehicles",
    },
    chrome: {
      sub: "Portneuf · Sector 4",
      menu: "Menu",
      main: "Main navigation",
      cockpitOnly: "Everything starts from the home screen.",
    },
    stayRules: {
      water: "Water not potable",
      bedding: "Bring bedding",
      nordquest: "Field map: NordQuest",
      sopfeu: "SOPFEU",
      atv: "ATV on trails only",
      drones: "No drones",
    },
    cockpit: {
      addTask: "+ Task",
      addPoint: "+ Point",
      addExpense: "+ Expense",
      addPhoto: "+ Photo",
      kpiPrep: "Prep",
      kpiTasks: "Open tasks",
      kpiPoints: "Points",
      kpiSpend: "Shared costs",
      kpiReady: "Members ready",
      sepaqFull: "Full Sépaq checklist",
    },
    today: {
      title: "Today",
      subtitle: "The group situation at a glance",
      nextTrip: "Next trip",
      dates: "Dates",
      sector: "Sector",
      participants: "Participants",
      countdown: "Countdown",
      datesPending: "Dates to confirm",
      openTrip: "Open the stay",
      addPoint: "Add a point",
      addPhoto: "Add a photo",
      addObservation: "Log an observation",
      writeGroup: "Write to the group",
      since: "Since my last visit",
      newPhotos: "New photos",
      newPoints: "New points",
      newObservations: "New observations",
      newMessages: "New messages",
      newExpenses: "Expenses added",
      openTasks: "Open tasks",
      map: "Territory map",
      recentPhotos: "Recent photos",
      noPhotos: "No photos yet",
      group: "Group",
      activity: "Recent activity",
      revisit: "Places to revisit",
      urgentTasks: "Urgent tasks",
      whatFound: "What did you find?",
      observe: "Observe",
      photo: "Photo",
      territory: "Ground",
      stay: "Camp",
      now: "Now",
      foodPending: "Food to confirm",
      confirmedMembers: "Confirmed members",
      nextStep: "Next step",
      menuCard: "Weekend menu",
      seeMenu: "Open full menu",
      createTask: "Create a task",
      myTasks: "My tasks",
      pointsCount: "points",
      priorityCount: "priority",
      revisitCount: "to revisit",
      openMap: "Open the map",
      expensesCard: "Shared costs",
      noExpense: "No expense entered",
      portneufHistory: "Portneuf history available",
      ourGround: "Our ground",
      addObs: "Add observation",
      seePoints: "See our points",
    },
    hunt: {
      kicker: "Our hunt",
      title: "Moose hunt 2026",
      subtitle: "2–9 October 2026 · Portneuf · Sector 4",
      datesLine: "From 2 October to 9 October 2026",
      place: "Portneuf · Sector 4",
      datesShort: "2–9 October 2026",
      departLine: "Departure: 2 October, around 6 a.m.",
      departDay: "Friday 2 October",
      arriveLine: "Expected arrival between 12 p.m. and 1 p.m.",
      arriveShort: "12 p.m.–1 p.m.",
      fieldMapLabel: "Field map",
      fieldMap: "NordQuest",
      daysBefore: "days before departure",
      work: {
        myTasks: "My things to do",
        gangTasks: "The gang",
        meals: "Meals",
        gear: "Gear",
        vehicles: "Vehicles",
        organization: "Organization",
        todo: "To do",
        done: "Done",
        todoN: "{n} to do",
        allDone: "All done ✓",
        humour: "Humour and stories",
        humourTitle: "The gang's jokes",
        jokes: "Jokes",
        anecdotes: "Stories",
        askMarcel: "To confirm with Marcel",
        photoValidate: "For Marcel to validate",
        imageJoke: "Humorous image",
        comingInfo: "More confirmed details later",
        orgTitle: "Hunt organization 2026",
        orgSubtitle: "2 to 9 October 2026 · Portneuf · Sector 4 · Desrochers",
        sepaqOfficial: "Official Sépaq information",
        groupInfo: "Group information",
        departHeading: "Departure",
        arriveHeading: "Expected arrival",
        registration: "Check-in",
        cabin: "Cabin",
        huntSection: "Hunt",
        services: "Services",
        onSite: "On site",
        nearby: "Nearby services",
        rules: "Good to know",
        officialDoc: "Open the official Sépaq document",
        pdfTitle: "Official Sépaq document",
        confirmTitle: "To confirm with Sépaq",
        confirmStatus: "To confirm",
        sepaqReady: "Official Sépaq organization is available",
        huntOrgSummary: "Departure: around 6 a.m. · Desrochers check-in: 1:45 p.m. · Hunt starts: 4:30 p.m.",
        bring: "To bring",
        schedule: "Schedule",
        territory: "Territory",
        group: "Group",
        notes: "Notes",
        expensesTitle: "Expenses",
        photos: "Photos",
        map: "Map",
        story: "Story",
        bilan: "Recap",
        prepProspectLine: "Scouting preparation — done",
        mealPlanned: "Planned meal",
        evening: "Evening",
        driver: "Driver",
        linkedGear: "Linked gear",
        ready: "Ready",
        addTask: "Add a task",
        taskPlaceholder: "What to do",
        edit: "Edit",
        reassign: "Reassign",
        reopen: "Reopen",
        oneThing: "1 thing to do",
        nThings: "{n} things to do",
        remove: "Delete",
        save: "Save",
        confirmDelete: "Do you really want to delete this item?",
        candidates: "Messenger candidates",
        approve: "Approve",
        duplicates: "Duplicates to confirm",
        trash: "Trash",
        restore: "Undo delete",
        addNote: "Add a note",
        downloadPdf: "Download the PDF",
        openPdf: "Open the PDF",
        pdfPreview: "Preview of the official document",
        pierreCheck: "A 26 September message says “Pierre: sausage and potatoes”. The official supper stays chicken until Marcel changes it.",
        person: "Person",
        everyone: "Everyone",
        messenger: "We will fill this in from Messenger.",
        datesBand: "2 to 9 October 2026",
        chalet: "Cabin",
        confirmed: "Confirmed information",
      },
      bilanWhen: "After 9 October",
      toolHistory: "Tool used during the August 2026 scouting: Avenza",
      phasePrep: "Getting ready for hunt 2026",
      noHuntDate: "Hunt date still open",
      nextStep: "Next step",
      prepare: "Get ready for hunt 2026",
      nextItems: {
        gear: "Gear",
        avenza: "Avenza",
        vehicles: "Vehicles",
        food: "Food",
        tasks: "Important tasks",
      },
      todo: "Before the hunt",
      todoEmpty: "Nothing urgent right now.",
      learned: "What we learned",
      learnedEmpty: "Field notes will show up here.",
      learnedKinds: {
        revisit: "Revisit",
        access: "Access",
        path: "Trail",
        promising: "Promising spot",
        obstacle: "Obstacle",
        moose: "Moose sign",
        note: "Field note",
        souvenir: "Memory",
      },
      ourProspect: "Our scouting trip",
      completed: "Done",
      current: "Now",
      upcoming: "Coming up",
      eightPeople: "8 people · 4 couples",
      sevenPeople: "7 people",
      sixHunters: "6 hunters",
      seePhotos: "See photos",
      seeExpenses: "See costs",
      seePoints: "See spots",
      seeSouvenirs: "See memories",
      seeDocs: "See papers",
      ourGround: "Our ground",
      sectorLine: "Sector 4 — 54.55 km²",
      strategicPoints: "useful spots",
      revisitCount: "to revisit",
      priorityCount: "priority",
      lastObs: "Latest note",
      openMap: "Open the map",
      ourPhotos: "Our photos",
      noPhotos: "Weekend photos will show up here.",
      ourGang: "Our crew",
      ourCosts: "Our costs",
      bilanPending: "Costs still to settle",
      ourHunt: "Our hunt",
      sevenPresent: "7 people there",
      phaseNow: "Current phase",
      prepProspectTitle: "Before scouting",
      prepHuntTitle: "Getting ready for the hunt",
      huntLiveTitle: "The 2026 hunt",
      afterHuntTitle: "After the hunt",
      nowPreparing: "What are we getting ready now?",
      detail: "More",
      cycleNav: "Hunt phases",
      tabMap: "Map",
      tabStory: "Story",
      tabBilan: "Costs",
      gpsAndPoints: "GPS photos + field spots",
      noPhotoGpsShort: "no GPS photos",
      unknown: "To confirm",
      joseeContrib: "Help before departure",
      prepTopics: {
        lodge: "Desrochers Cabin",
        transport: "transport",
        food: "food",
        maps: "maps",
        group: "crew",
        docs: "papers",
      },
      afterDest: {
        photos: "photos",
        results: "results",
        souvenirs: "memories",
        expenses: "costs",
        observations: "notes",
        final: "final recap",
      },
      rail: {
        prep_prospect: "Before scouting",
        prospection: "Scouting",
        preparation_hunt: "Hunt prep",
        hunt: "Hunt",
        bilan: "After",
      },
      mobileTabs: {
        prep_prospect: "Before",
        prospection: "Scouting",
        preparation_hunt: "Prep",
        hunt: "Hunt",
        bilan: "After",
      },
      phases: {
        prep_prospect: "Before scouting",
        prospection: "Scouting",
        preparation_hunt: "Prep",
        hunt: "Hunt",
        bilan: "After",
      },
      openProspect: "Open the scouting trip",
      huntCard: "Hunt 2026",
      timeline: "The weekend",
      timelineSteps: {
        prep: "prep",
        depart: "leave",
        arrive: "arrival",
        field: "field",
        meals: "meals",
        return: "return",
      },
      weekendPeople: "There that weekend",
      pierreRobinOut: "Pierre was not on that weekend. He stays in the hunt. Robin was not there either, and he is not on this hunt.",
      seeProspect: "Look back at scouting",
      souvenirsTitle: "Scouting memories",
      souvenirsLead: "Photos, meals, stories — no technical clutter.",
      anecdotes: "Stories",
      meals: "Meals",
      groupShots: "Group",
      vehicleShots: "Vehicles",
      prospectTitle: "Portneuf scouting",
      groupHunt: "Hunt 2026 crew",
      prospectDates: "28–30 August 2026",
      weekendStory: "Our scouting trip — the weekend in pictures and stories",
      weekendSub: "28–30 August 2026 · Desrochers Cabin · Sector 4",
      photosProspect: "Our scouting photos",
      photosWord: "photos",
      souvenirsWord: "memories",
      pointsWord: "field spots",
      lived: "What we lived",
      livedEmpty: "Memories will show here after the weekend import.",
      seeTalk: "Read the talks",
      discussions: "Our talks",
      talkEmpty: "No talks to show.",
      talkFilters: {
        all: "All",
        organisation: "Planning",
        bouffe: "Food",
        territoire: "Ground",
        vehicules: "Vehicles",
        depenses: "Costs",
        souvenirs: "Memories",
      },
      tabPhotos: "Photos",
      tabTalk: "Talks",
      tabGround: "Ground",
      tabSouvenirs: "Memories",
      tabCosts: "Costs",
      nextChapter: "Next chapter",
      perCouple: "/ couple",
      albumName: "Portneuf scouting — 28–30 August 2026",
      chapterResume: "Summary",
      chapterMap: "Map",
      prospectPoints: "Our scouting spots",
      nosSouvenirs: "Our memories",
      reviewWeekend: "Review our weekend",
      gangPresent: "The crew who was there",
      joseeAway: "Josée was not on site (sick).",
      ourStory: "Our story",
      storyLead: "Messenger send times. Photos have no EXIF or GPS (Facebook stripped them). Titles need confirmation.",
      suggested: "Suggested title",
      mapWeekend: "Weekend map",
      noPhotoGps: "No photo in this set has GPS. Sector 4 and field points only.",
      allPhotos: "All photos",
      weekendCost: "What the weekend cost us",
    },
    expedition: {
      kicker: "Expedition",
      title: "PORTNEUF 2026 EXPEDITION",
      subtitle: "Desrochers Cabin — Sector 4",
      departBadge: "28–30 Aug 2026",
      reserveBadge: "Portneuf Wildlife Reserve",
      sectorBadge: "Hunting sector 4",
      reconBadge: "54.55 km²",
      memberBadge: "6 members",
      countdown: "Early morning leave — exact hour still open",
      arrive: "Official cabin arrival from 5 p.m.",
      mapNote: "Official sector 4 limit — 54.55 km². Field map: NordQuest.",
      timelineTitle: "Itinerary",
      compactLine: "Sector 4 → Desrochers Cabin → Back Sunday 1:30 p.m.",
      summary: "Friday 28 to Sunday 30 August 2026. Desrochers Cabin, hunting sector 4, 54.55 km².",
      ourLodge: "Our cabin",
      seeLodge: "Open the card",
      seeSepaq: "View on Sépaq",
      seePhotos: "Official photos",
      territoryBlock: "Sector 4 — 54.55 km²",
      seeMap: "View map",
      fullscreen: "Full screen",
      myPoints: "My points",
      openNav: "Open navigation",
      steps: { prep: "Prep", friday: "Friday 28", saturday: "Saturday 29", sunday: "Sunday 30" },
      days: { prep: "Before leaving", friday: "Early morning leave", saturday: "Field day", sunday: "Checkout 1:30 p.m." },
      places: { prep: "Sépaq checklist", friday: "Desrochers Cabin from 5 p.m.", saturday: "Sector 4", sunday: "Desrochers Cabin" },
      notes: { prep: "Water, bedding, NordQuest, papers.", friday: "Charcuterie. Wine: Josée.", saturday: "Natalie's crêpes. Filet mignon + dauphinoise potatoes.", sunday: "Quick breakfast prepared ahead." },
    },
    avenza: {
      open: "Open NordQuest",
      copy: "Copy coordinates",
      exportGpx: "Export GPX",
      importGpx: "Import GPX / KML",
      note: "Former tool used during scouting: Avenza. The group field map is now prepared in NordQuest.",
      officialMap: "Former tool — August scouting",
      lakeTitle: "Lac Desrochers",
      sourceLine: "Source: Sépaq · Platform: Avenza Maps",
      lakeRef: "Lake reference — distinct from Desrochers Cabin and sector 4.",
      seeOfficial: "See official Avenza map",
      qrAlt: "QR to the official Avenza Lac Desrochers listing",
      downloaded: "Avenza map downloaded",
      yes: "Yes",
      no: "No",
      unknown: "To confirm",
      importBtn: "Import Avenza data",
      exportMineGpx: "Export my GPX points",
      exportMineKml: "Export my KML points",
      exportAllGpx: "Export group GPX",
      exportAllKml: "Export group KML",
      imported: "{n} points · {t} tracks",
      importQueued: "File kept offline — import when back online.",
      importNeedNet: "Import needs a connection. The file was not discarded; try again.",
      openPanel: "Avenza",
    },
    territory: {
      title: "Territory",
      subtitle: "Points, trails and field notes",
      search: "Search a point",
      filterCategory: "Category",
      filterSector: "Sector",
      all: "All",
      empty: "No point found",
      add: "Add a point",
      name: "Name",
      category: "Category",
      comment: "Comment",
      interest: "Interest",
      save: "Save the point",
      detail: "Point details",
      expand: "Expand",
      openMap: "Map",
      recenter: "Recenter",
      layers: { standard: "Standard", topo: "Relief", satellite: "Satellite" },
    },
    photos: {
      title: "Photos",
      subtitle: "Memories, tracks and territory",
      add: "Add a photo",
      empty: "No photo found",
      search: "Search",
      category: "Category",
      comment: "Comment",
      albumTitle: "All photos",
      albumLead: "Chronological order. A place only if real GPS exists.",
      noPlace: "Place unknown",
      missingFiles: "unreadable file(s) — admin only.",
    },
    trip: {
      title: "Stay",
      subtitle: "Desrochers Cabin — preparation",
      lodgeTitle: "Desrochers Cabin",
      reception: "Registration",
      motorized: "Motor travel",
      nearby: "Nearby services",
      navField: "Field navigation",
      food: "Food",
      tasks: "Tasks",
      expenses: "Expenses",
      resources: "Useful resources",
      toConfirm: "To confirm",
      item: "Item",
      responsible: "Owner",
      quantity: "Quantity",
      cost: "Cost",
      participants: "Participants",
      historyTitle: "Portneuf history",
      souvenirsTitle: "Memories",
    },
    lodging: {
      title: "Desrochers Cabin",
      subtitle: "Official lodging for the trip",
      unknown: "Not confirmed",
      source: "Official source",
      folder: "Portneuf / Desrochers",
      photosNote: "Official photos stay on the Sépaq site. None are reused here.",
      unit: "Unit / number",
      gps: "Cabin coordinates",
      capacity: "Capacity",
      holder: "Holder",
      water: "Water is not potable — bring bottled water",
      waterStatus: "CRITICAL",
      groupBed: "Group tip: individual sleeping bag",
      provided: "Provided: pillows, bath mats, dish towels, dishes, utensils, pots, pans, percolator or press.",
      notProvided: "Not provided: salt, pepper, oil, sugar, basic food.",
    },
    prep: {
      title: "Trip prep",
      subtitle: "Desrochers Cabin — Portneuf Wildlife Reserve",
      card: "Trip prep",
      readyOf: "ready",
      toLoad: "to load",
      criticalLeft: "critical to check",
      beforeLeave: "Fix before leaving",
      who: "Who brings what",
      knownOnly: "Known duties only — nothing invented",
      essentials: "Must-have for this outing",
      essentialsReady: "must-haves ready",
      seeFull: "See the full Sépaq checklist",
      myTasks: "Tasks that concern me",
      loading: "Loading",
      depart: "Ready to leave?",
      go: "READY TO LEAVE",
      left: "items to check",
      filterAll: "All",
      filterMine: "Me",
      filterGroup: "Group",
      filterCrit: "Critical",
      winter: "Show winter gear",
      hideWinter: "Hide winter",
      markReady: "Ready",
      markLoaded: "Loaded",
      markCheck: "Confirmed",
      avenzaBtn: "Open NordQuest",
      avenzaWarn: "The offline map is prepared in NordQuest before you leave.",
      source: "Official source",
      sourceNote: "Sépaq — cabin aide-memoire. Reference content.",
      openPdf: "Open",
      downloadPdf: "Download",
      addSepaq: "Add Sépaq checklist",
      hunting: "Hunting gear",
      huntingEmpty: "Empty for now — fill later.",
      joseeDuty: "food",
      natalieDuty: "Saturday breakfast",
      grocery: "Shared grocery",
      menus: "Menus",
      qty: "Quantity",
      note: "Note",
      expense: "Add an expense",
      personal: "Personal prep",
      meals: { friday: "Friday", saturday: "Saturday", sunday: "Sunday", other: "Other meals" },
      cats: { important: "Important", vetements: "Clothes", hiver: "Winter clothes", effets: "Personal kit", groupe: "Group gear", epicerie: "Grocery", chasse: "Hunting gear" },
    },
    nordquest: {
      groupTitle: "NordQuest — group prep",
      readyOf: "hunters ready",
      pointsOfficial: "9 official points",
      sector: "sector 4",
      offline: "offline map",
      updated: "last update",
      noneYet: "not yet",
      versionLine: "9 points Éric — prospection 29 août 2026",
      version: "Version 1",
      title: "Set up my NordQuest",
      subtitle: "Official group field map — Portneuf, sector 4",
      open: "Open NordQuest",
      step1: "1. Install NordQuest",
      appStore: "iPhone",
      play: "Android",
      installed: "NordQuest installed ✅",
      installedOff: "Confirm: NordQuest is installed",
      step2: "2. Open the Portneuf map",
      step2how: "NordQuest → Territories → Sépaq → Réserve faunique de Portneuf",
      step2sector: "Open sector 4",
      mapOpen: "Portneuf map open ✅",
      mapOpenOff: "Confirm: Portneuf map is open",
      step3: "3. Download our 9 points",
      download: "Download Eric's 9 points",
      gpxFallback: "KML failed? Download the GPX",
      step4: "4. Import into NordQuest",
      importTitle: "Import the points",
      importSteps: [
        "Open NordQuest",
        "Open the Portneuf map or territory",
        "Tap Actions",
        "Choose Import",
        "Choose the downloaded KML file",
        "Confirm",
        "Check the 9 points on the map",
      ],
      step5: "5. Check the points",
      verifyTitle: "Check",
      verifyLead: "You should see 9 points",
      seeNine: "I see the 9 points ✅",
      seeNineOff: "Confirm: I see the 9 points",
      history: "Former tool used during scouting: Avenza",
      step6: "6. Offline map",
      woods: "Get ready for the bush",
      woodsHow: "Download the NordQuest map for offline use before you leave.",
      offlineReady: "Offline map ready ✅",
      offlineTodo: "Still to do",
      imReady: "I am ready",
      track: "Tracking for the 6 hunters",
      yes: "Yes",
      no: "No",
      rowInstalled: "NordQuest installed",
      rowMap: "Portneuf map open",
      rowPoints: "9 points imported",
      rowOffline: "Offline map",
      rowReady: "Ready",
      associates: "Chantal, Josée, Natalie and Martine can view this page. Tracking is for the 6 hunters.",
      chalet: "Cabin setup",
      chaletHint: "Tap a name to see what is left.",
      qrCaption: "At the cabin, scan this code to open this page.",
      notHunter: "The main tracking is for the 6 hunters.",
      mapNote: "New field points are now created in NordQuest.",
    },
    menu: {
      title: "Trip menu",
      subtitle: "Food lead: Josée Gravelle",
      lead: "Josée Gravelle",
      coord: "Food lead: Josée Gravelle",
      fridayNoon: "Friday noon",
      fridayEve: "Friday evening",
      satBreakfast: "Saturday morning",
      satLunch: "Saturday lunch",
      satDinner: "Saturday dinner",
      sunday: "Sunday morning",
      drinks: "Drinks",
      drinksRule: "Each person brings their own drinks, with or without alcohol.",
      createTask: "Create a task",
      allergies: "Food allergies: none confirmed",
      snacks: "Snacks for the trucks",
      hunters: "Hunters",
      lodge: "At the cabin",
    },
    know: {
      title: "Before you leave",
      subtitle: "Confirmed rules — Sépaq confirmation",
    },
    vehicles: {
      title: "Vehicles",
      subtitle: "Real photos — details still open",
      pending: "Details still open",
    },
    group: {
      title: "Group",
      subtitle: "Our 2026 hunt crew",
      toConfirm: "Member to confirm",
      active: "Active",
      admin: "Administrator",
      member: "Member",
      associated: "Associated person",
      associatedTitle: "Associated people",
      organizer: "Organizer",
      hunter: "Hunter",
      official: "Hunters / organizers",
      foodLead: "Food lead",
    },
    more: {
      title: "More",
      subtitle: "Messages, expenses, documents and settings",
    },
    messages: {
      title: "Messages",
      subtitle: "Group channels",
      write: "Write",
      send: "Send",
      empty: "No messages in this channel",
      source: "Source",
      importedSources: "Imported sources",
      importedNote: "Messenger — excerpt supplied by hand. No access to the full group.",
    },
    expenses: {
      title: "Expenses",
      subtitle: "Who paid, who owes what",
      add: "Add an expense",
      payer: "Paid by",
      amount: "Amount",
      description: "Description",
      category: "Category",
      total: "Total",
      perPerson: "Per person",
      whoOwes: "Who reimburses whom",
      empty: "No expense found",
      tripCard: "Trip costs",
      paidByMe: "Paid by me",
      myShare: "My share",
      balance: "Balance",
      rule: "Everyone totals the shared costs they paid, then we add them up and split equally among the 6 official members.",
      none: "No expense entered",
      includeLodge: "Include in shared costs",
      pendingLodge: "Desrochers Cabin — split not activated",
      reminder: "Each person enters their shared costs.",
      missing: "missing expenses",
    },
    documents: {
      title: "Documents",
      subtitle: "Permits, maps and notes",
      empty: "No documents yet",
      folder: "Portneuf / Desrochers",
      open: "Open",
      aideMemoire: "Aide-mémoire — Équipement pour un séjour en chalet",
      officialMap: "Portneuf Wildlife Reserve — Moose hunt 2026 — Sector 4",
      reservation: "Reservation confirmation",
      kmz: "POR_Secteur_Chasse_Orignal.kmz",
      officialMaps: "Official maps",
    },
    history: {
      title: "History",
      subtitle: "Group activity log",
      empty: "No activity",
      avenzaPast: "Former tool used during scouting: Avenza",
    },
    settings: {
      title: "Settings",
      subtitle: "Account, version and environment",
      version: "Version",
      env: "Environment",
      build: "Build",
      commit: "Commit",
      deployed: "Deployed",
    },
    status: {
      preparation: "Preparation",
      confirmed: "Confirmed",
      in_progress: "In progress",
      cancelled: "Cancelled",
      completed: "Done",
      upcoming: "Coming up",
      current: "Now",
      to_confirm: "To confirm",
      active: "Active",
      open: "To do",
      doing: "In progress",
      done: "Done",
      member_to_confirm: "Member to confirm",
      invitation_pending: "Invitation pending",
      to_bring: "To bring",
      ready: "Ready",
      loaded: "Loaded",
      to_plan: "To pack",
      assigned: "Assigned",
      to_check: "To check",
      not_needed: "Not needed",
      faible: "Low",
      interessant: "Interesting",
      important: "Important",
      prioritaire: "Priority",
    },
    observations: { title: "Observations", subtitle: "What the group saw in the field", empty: "No observations", add: "Add an observation", note: "Optional note" },
    tasksPage: {
      title: "Tasks",
      subtitle: "Who does what before and during the outing",
      empty: "No tasks",
      create: "Create a task",
      titleField: "Title",
      desc: "Notes",
      assignee: "Owner",
      unassigned: "Unassigned",
      comment: "Comment",
      addComment: "Add",
      reopen: "Reopen",
      prioNormal: "Normal",
      prioHigh: "High",
      prioUrgent: "Urgent",
      mine: "My tasks",
    },
    mapUi: {
      myPos: "My position",
      strategic: "Strategic point",
      fitSector: "See the whole sector",
      filters: "Filters",
      layers: "Layers",
      show: "Show",
      allMembers: "All hunters",
      locating: "Looking for position…",
      denied: "Location permission denied",
      noGps: "Position unavailable",
      useHere: "Current position",
      tapMap: "Tap the map",
      needPlace: "Choose a position",
      revisit: "Revisit",
      views: { all: "All", mine: "My points", others: "Others", priority: "Priority", revisit: "Revisit", obs: "Signs", acces: "Access" },
      interest: { normal: "Normal", interesting: "Useful", important: "Important", priority: "Priority" },
    },
    gear: { title: "Gear", subtitle: "Shared list — nothing is invented", empty: "No gear yet" },
    searchPage: { title: "Search", subtitle: "Messages, photos, points, members, trips", empty: "No results" },
    notifications: { title: "Notifications", subtitle: "Mentions, tasks and trips", empty: "No notifications" },
    admin: { title: "Admin", subtitle: "Invites, health, version and Facebook import", invite: "Invite a member", system: "System" },
    rebuild: {
      title: "Rebuild our scouting weekend",
      lead: "DEV only. Confirm or correct each moment. Nothing goes to PROD.",
      present: "Present",
      answerPh: "Your answer",
      saveAnswer: "Save",
      saved: "Saved",
      suggested: "Suggested title",
      unconfirmed: "to confirm",
      confirm: "Confirm",
      correct: "Correct",
    },
    fbImport: {
      title: "Facebook Portneuf import",
      lead: "Human validation required. Nothing enters the cockpit without approval.",
      load: "Load candidates (local)",
      loaded: "Candidates loaded",
      loadError: "Extract folder missing",
      previewImport: "Summary before import",
      confirmImport: "Import approved items",
      cancelImport: "Undo this import",
      imported: "Import complete",
      importError: "Import failed",
      noMass: "No bulk dump: every item stays Pending until you approve it.",
      authors: "Facebook authors",
      ambiguous: "Ambiguous author — Chantal / Luc",
      historical: "Historical author (not an active member)",
      knownExpenses: "Known expenses to validate",
      found: "found",
      missing: "not found",
      approve: "Approve",
      reject: "Reject",
      bulkApproveCat: "Category + approve selection",
      bulkReject: "Reject selection",
      duplicate: "summary duplicate",
      keep: "keep",
      confirmDesc: "Description to confirm",
      previewLine: "{m} messages · {p} photos · {e} expenses · {d} documents · {s} memories",
      tabs: {
        resume: "Summary", messages: "Messages", depenses: "Expenses", photos: "Photos",
        territoire: "Territory", nourriture: "Food", taches: "Tasks", sejour: "Stay",
        vehicules: "Vehicles", souvenirs: "Memories", ignores: "Ignored", importes: "Imported",
      },
      kpis: {
        messages: "Messages", photos: "Photos", videos: "Videos", attachments: "Attachments",
        expense_rows: "Expense candidates", tache: "Tasks", nourriture: "Food",
        territoire: "Territory", vehicule: "Vehicles", sejour: "Stay", souvenir: "Memories",
      },
      status: { to_validate: "Pending", approved: "Approved", rejected: "Rejected", imported: "Imported", sensitive_excluded: "Secret excluded" },
      photoCats: {
        groupe: "Group", chalet: "Cabin", territoire: "Territory", repas: "Meal", vehicule: "Vehicle",
        facture: "Receipt", document_financier: "Finance document", souvenir: "Memory", autre: "Other", a_classer: "To sort",
      },
    },
    trips: { title: "Trips", subtitle: "Preparation, in progress, done", empty: "No trips" },
    categories: {
      orignal: "Moose sign",
      feces: "Droppings",
      zone_nourriciere: "Feeding area",
      position: "Useful spot",
      cache: "Blind / stand",
      chemin: "Trail",
      sentier: "Path",
      frottage: "Rubbing",
      souille: "Wallow",
      passage: "Crossing",
      nourriture_naturelle: "Natural food",
      secteur_interessant: "Interesting sector",
      acces: "Access",
      camp: "Camp",
      stationnement: "Parking",
      observation: "Observation",
      traces: "Tracks / signs",
      eau: "Water",
      obstacle: "Obstacle",
      revoir: "Sector to revisit",
      photo: "Photo",
      autre: "Other",
      territoire: "Territory",
      groupe: "Group",
      equipement: "Gear",
      nourriture: "Food",
      souvenir: "Memory",
      essence: "Fuel",
      hebergement: "Lodging",
      materiel: "Equipment",
      permis: "Permit",
      transport: "Transport",
      vehicule: "Vehicles",
      chalet: "Cabin",
      repas: "Meal",
      facture: "Receipt",
      boissons_communes: "Shared drinks",
      essence_commune: "Shared fuel",
      glace: "Ice",
      a_classer: "To sort",
    },
    channels: {
      general: "General",
      territoire: "Territory",
      bouffe: "Food",
      organisation: "Planning",
      photos: "Photos",
    },
    errors: {
      login: "Invalid username or password",
      network: "Network unavailable — draft kept",
      notFound: "Page not found",
      expired: "Session expired — sign in again",
    },
    help: {
      close: "Close help",
    },
    demo: {
      badge: "[DEMO]",
      imported: "Messenger import",
    },
  },
};

export function tNs(lang, path, fallback) {
  const parts = path.split(".");
  let cur = orignalI18nNamespaces[lang] || orignalI18nNamespaces.fr;
  for (const part of parts) {
    if (!cur || typeof cur !== "object") return fallback ?? path;
    cur = cur[part];
  }
  return typeof cur === "string" ? cur : fallback ?? path;
}

export function localizeDemo(text, lang = "fr") {
  if (!text || lang === "fr") return text;
  return String(text)
    .replace(/\[DÉMO\]/g, "[DEMO]")
    .replace(/à confirmer/gi, "to confirm")
    .replace(/À confirmer/g, "To confirm")
    .replace(/Préparation/g, "Preparation")
    .replace(/Nouvelle recrue/g, "New recruit")
    .replace(/source Messenger/gi, "Messenger source")
    .replace(/Non officiel/g, "Unofficial")
    .replace(/patates dauphinoises/gi, "dauphinoise potatoes")
    .replace(/Nourriture pour le groupe/g, "Food for the group")
    .replace(/Commande Fort-Coulonge/g, "Fort-Coulonge order")
    .replace(/Sortie terrain 3 jours/g, "3-day field trip")
    .replace(/EXPÉDITION PORTNEUF 2026/g, "PORTNEUF 2026 EXPEDITION")
    .replace(/Territoire Orignal 2026 — à confirmer/g, "Moose 2026 territory — to confirm");
}

export function demoBadge(lang = "fr") {
  return lang === "en" ? "[DEMO]" : "[DÉMO]";
}
